<ng-content></ng-content>
<span class="badge" 
  [class.small]="small">
  {{ number }}
</span>